import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useNavigateNext from "./useNavigateNext";
import { useAuth } from "../../auth/AutoContextProvider";

const TypeFormNavigator = () => {
  const [_, {sso, getCookie , getInitialGuestToken ,getFinalGuestToken, setRole}]= useAuth()
  const location = useLocation();
  const [searchParams, navigateNext] = useNavigateNext(location)
  const abort = new AbortController()
  const navigate = useNavigate();

  useEffect(() => {
    const tokenParam = searchParams.get('token')
    const refreshParam = searchParams.get('refresh')
    
    const performSso = async () => {
      if (tokenParam) {
        const ssoData = await sso(tokenParam, refreshParam);
        if (ssoData) {
          navigate(`/TypeForm/form/${process.env.REACT_APP_TYPEFORM_FORM_ID}`)
        } else {
          location.googleSignIn = true;
          navigateNext('/');
        }
      } else {
        const token = getCookie('tkn-ath')
        const refresh = getCookie('tkn-ath-rfrsh')
        const role = getCookie('tkn-ath-role')
        if (token) {
          try {
            const getSso = await sso(token, refresh, role);
            if(getSso) {
              navigate(`/TypeForm/form/${process.env.REACT_APP_TYPEFORM_FORM_ID}`)
            }else{
              navigateNext('/');
            }
          } catch (err) {
            navigateNext('/');
          }
        } else {
          await getInitialGuestToken()
          .then(url=>{
            getFinalGuestToken(url.refresh_token)
            .then(data=>{
              sso(data.token,data.refresh_token,data.role)
              setRole(data.role)
              navigate(`/TypeForm/form/${process.env.REACT_APP_TYPEFORM_FORM_ID}`)
            })
          })
        }
      }
    };
  
    performSso();
  
    return () => {
      abort.abort();
    };
  },[])
}

export default TypeFormNavigator